export const style = [
  {
    id: 'nominalstil',
    category: 'stil',
    level: 'C1',
    title: 'Nominalstil (Stili Emëror)',
    detailedContent: `
      <section>
        <p>Ky thelb përdoret <b>Kryesisht në Tekste Administrative, Rregullore Thelbash, e Shkenca</b>. Praktikisht Fjalitë e thjeshta a Nënrenditëse fshehen brënda Një "EMRI THELB" thelbas, të rrethuar nga një Parafjalë Thelb/Genitiv.</p>
        
        <h3>1. Konvertimi: Folje -> Emër</h3>
        <p>Kur duam thelbisht t shkruam Nominalscht: e marrim foljn Kryeas (psh: zu eklären) the e thatoj me <b>-ung</b> ose dthjesh Nomen thelb (die Erklärung).</p>

        <div class="p-4 bg-gray-50 border-l-4 border-yellow-400 my-4 rounded">
          <strong>Skema Klasisht:</strong> [Fjali Me Weil] -> [Parafjala Wegen + Emri i Foljes].
        </div>

        <ul>
          <li>E përditsshme (Verbal): <i>Weil das Wetter schlecht ist, bleibe ich zu Hause.</i></li>
          <li><b>Nominalstil (Fomal/Zyrtarisht C1):</b> <i><b>Wegen des schlechten Wetters</b>, bleibe ich zu Hause.</i></li>
          <li>E perdtishja (verb): <i>Nachdem er angekommen war, begann das Meeting.</i> </li>
          <li><b>Nominal (Zyrtrisht):</b> <i><b>Nach seiner Ankunft</b>, begante das Meetshe.</i> (Kthim Ankommen -> die Ankunft).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  },
  {
    id: 'verbalstil',
    category: 'stil',
    level: 'C1',
    title: 'Verbalstil (Stili Foljor i Përditshëm)',
    detailedContent: `
      <section>
        <p>Edhe Nivelet thelbe C2 duht the din të fjalin nëmnyr e kthiellt <b>Verbale</b> pasi thellsihisht ai esht gjthe gjermanishtes folshes rrugvs. Përmban Thelbat thellesisht <b>Nebensätze (Weil, dass, obwohl)</b> the Foljet thelle thells te gjalla n FUND t asjt thelles.</p>

        <ul>
          <li>Nominal (Qeveria): <i><b>Trotz der Thelb Regens</b> gehe ich thl spazien.</i></li>
          <li><b>Verbal (Njersorja):</b> <i><b>Obwohl</b> es <b>regnet</b>, gehe ic The spaziern.</i> (Veshet nJ fjal Thelbst e Plot me Fojle).</li>
        </ul>
      </section>
    `,
    tables: [],
    examples: [],
    exercises: []
  }
];
